export default (baseUrl: string | null = null, defaultCjEventCookie: string | null = null) => {
    baseUrl = baseUrl || useRoute().fullPath
    const urlPrefix = useRuntimeConfig().public.mobileAppLinkPrefix

    let deepLinkValue = baseUrl

    // add cjevent to the url. Check for & and ? in the url
    const cjEventCookie = useCjEventCookie().value || defaultCjEventCookie
    if (cjEventCookie) {
        deepLinkValue += `${deepLinkValue.includes('?') ? `&` : `?`}cjevent=${cjEventCookie}`
    }

    return `${urlPrefix}?deep_link_value=${encodeURIComponent(deepLinkValue)}`
}
